/* eslint-disable react/prefer-stateless-function,no-useless-constructor,no-undef */
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import App from './pages/App';
import AdminApp from './components/admin/containers/App';
import OAuth2 from './helpers/OAuth2';
import Oauth from './constants/OAuth2';
import { getUrlParams } from './constants/utils';


class AppRoute extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expired: false,
    };
  }

  componentWillReceiveProps() {
    const expireDate = localStorage.getItem('expireDate');

    if (expireDate != null) {
      const now = moment(moment.now());
      const formattedExpireDate = moment(parseInt(expireDate));
      const duration = now.diff(formattedExpireDate, 'seconds');

      if (duration > 0) {
        this.setState({ expired: true });
      }
    }
  }


  render() {
    const { rehydrate, auth } = this.props;
    const { url, redirectUri,dakikaUrl } = Oauth;

    if (rehydrate.loaded) {
      const isTokenExpired = localStorage.getItem('tokenExpired');
      const urlParams = getUrlParams();
      const urlCode = urlParams.code;
      const lastLoginCode = localStorage.getItem('lastLoginCode');
      const referrer = document.referrer;
      const { galleryRedirect } = Oauth;
      const isFromGallery = referrer && galleryRedirect && referrer.includes(galleryRedirect);

      if (auth.isActive === false) {
        localStorage.clear();
        window.location = `${dakikaUrl}/payroll/logout.xhtml`
      }

      if ((isTokenExpired && isTokenExpired === 'true') || this.state.expired === true || auth.error) {
        localStorage.clear();
        window.location = `${dakikaUrl}/payroll/logout.xhtml`
      }

      if (!auth.user) {
        return <OAuth2 key="oauth2" />;
      }

      if (urlCode && urlCode !== lastLoginCode) {
        return <OAuth2 key="oauth2" />;
      }

      // Gallery'den code olmadan gelindiyse, SSO kontrolü için OAuth2'ye düş
      if (isFromGallery && !urlCode) {
        return <OAuth2 key="oauth2" />;
      }

      if (auth.employeeView) {
        return <App key="app" {...this.props} />;
      }

      return <AdminApp key="adminapp" {...this.props} />;
    }

    return (
      <span>
        Loading...
      </span>
    );
  }
}

const mapStateToProps = state => ({
  rehydrate: state.rehydrate,
  auth: state.auth,
});

export default connect(mapStateToProps)(AppRoute);



// WEBPACK FOOTER //
// ./src/AppRoute.js